// extracted by mini-css-extract-plugin
export var category = "_jn-9";
export var categoryHeader = "_jn-e";
export var container = "_jn-0";
export var group = "_jn-a";
export var groupItems = "_jn-f";
export var groupSeparator = "_jn-j";
export var loading = "_jn-1";
export var noResults = "_jn-3";
export var placeholder = "_jn-2";
export var resultContent = "_jn-5";
export var resultIcon = "_jn-c";
export var resultItem = "_jn-g";
export var resultMeta = "_jn-8";
export var resultSubtitle = "_jn-7";
export var resultSuffix = "_jn-i";
export var resultTitle = "_jn-6";
export var resultsList = "_jn-4";
export var searchGroup = "_jn-d";
export var selected = "_jn-h";
export var subgroup = "_jn-b";